const $inject = [];
const lbaBoolean = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaBooleanCtrl',
    controllerAs: 'vm',
    template: require('./lbaBoolean.html')
  }
};

lbaBoolean.$inject = $inject;

export default lbaBoolean;



// WEBPACK FOOTER //
// ./src/components/lbaBoolean/lbaBooleanDir.js